import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../../Logo';
import { routeWarmProps } from '@/perf/routePreload';

type AgoraLogoProps = {
  href: string;
};

export const AgoraLogo: FunctionComponent<AgoraLogoProps> = ({ href }) => (
  <Link aria-label="Ágora" className="leading-none text-frost-ink" to={href} {...routeWarmProps(href)}>
    <Logo type="horizontal" width="96px" height="48px" />
  </Link>
);
